import React from 'react';
import classNames from 'classnames';

const StepIcon = ({
  className, size, ...rest
}) => (
  <svg className={classNames(`w-${size} h-${size}`, className)} aria-label="steps" viewBox="0 0 512 512" {...rest}>
    <g>
      <path d="M492.8,142.4a16,16,0,0,0-22.4-3.2L464,144V104a48.05,48.05,0,0,0-48-48H376V16A16,16,0,0,0,360,0H152a16,16,0,0,0-16,16V128a16,16,0,0,0,16,16H360a16,16,0,0,0,16-16V88h40a16,16,0,0,1,16,16v40l-6.4-4.8a16,16,0,1,0-19.2,25.6L432,184v40a16,16,0,0,1-16,16H376V200a16,16,0,0,0-16-16H152a16,16,0,0,0-16,16v40H96a48.05,48.05,0,0,0-48,48v48l-6.4-4.8a16,16,0,1,0-19.2,25.6L48,376v32a48.05,48.05,0,0,0,48,48h40v40a16,16,0,0,0,16,16H360a16,16,0,0,0,16-16V384a16,16,0,0,0-16-16H152a16,16,0,0,0-16,16v40H96a16,16,0,0,1-16-16V376l25.6-19.2a16,16,0,0,0-19.2-25.6L80,336V288a16,16,0,0,1,16-16h40v40a16,16,0,0,0,16,16H360a16,16,0,0,0,16-16V272h40a48.05,48.05,0,0,0,48-48V184l25.6-19.2A16,16,0,0,0,492.8,142.4ZM344,112H168V32H344ZM168,400H344v80H168ZM344,296H168V216H344Z"/>
    </g>
  </svg>
)

export default StepIcon;
